"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var App_1 = require("../../App");
var useInterval_1 = __importDefault(require("./useInterval"));
var numRows = 25;
var numCols = 35;
// Directions: N, S, E, W, NE, NW, SE, SW
var operations = [
    [0, 1], // right
    [0, -1], // left
    [1, -1], // top left
    [-1, 1], // top right
    [1, 1], // top
    [-1, -1], // bottom
    [1, 0], // bottom right
    [-1, 0], // bottom left
];
var generateEmptyGrid = function () {
    var rows = [];
    for (var i = 0; i < numRows; i++) {
        rows.push(Array.from(Array(numCols), function () { return 0; }));
    }
    return rows;
};
var randomTiles = function () {
    var rows = [];
    for (var i = 0; i < numRows; i++) {
        rows.push(Array.from(Array(numCols), function () { return (Math.random() > 0.7 ? 1 : 0); }));
    }
    return rows;
};
var Life = function () {
    var _a = (0, App_1.useEloise)(), theme = _a.theme, logic = _a.logic;
    var _b = (0, react_1.useState)(function () {
        return randomTiles();
    }), grid = _b[0], setGrid = _b[1];
    var _c = (0, react_1.useState)(true), running = _c[0], setRunning = _c[1];
    var runningRef = (0, react_1.useRef)(running);
    runningRef.current = running;
    var runSimulation = (0, react_1.useCallback)(function (grid) {
        if (!runningRef.current) {
            return;
        }
        var gridCopy = JSON.parse(JSON.stringify(grid));
        var _loop_1 = function (i) {
            var _loop_2 = function (j) {
                var neighbors = 0;
                operations.forEach(function (_a) {
                    var x = _a[0], y = _a[1];
                    var newI = i + x;
                    var newJ = j + y;
                    if (newI >= 0 && newI < numRows && newJ >= 0 && newJ < numCols) {
                        neighbors += grid[newI][newJ];
                    }
                });
                if (neighbors < 2 || neighbors > 3) {
                    gridCopy[i][j] = 0;
                }
                else if (grid[i][j] === 0 && neighbors === 3) {
                    gridCopy[i][j] = 1;
                }
            };
            for (var j = 0; j < numCols; j++) {
                _loop_2(j);
            }
        };
        for (var i = 0; i < numRows; i++) {
            _loop_1(i);
        }
        setGrid(gridCopy);
    }, []);
    (0, useInterval_1.default)(function () {
        runSimulation(grid);
    }, 150);
    return (react_1.default.createElement("div", { className: "container  py-1`" },
        react_1.default.createElement("div", { style: {
                display: "grid",
                gridTemplateColumns: "repeat(".concat(numCols, ", 20px)"),
                width: "fit-content",
                margin: "0 auto",
            } }, grid.map(function (rows, i) {
            return rows.map(function (col, k) { return (react_1.default.createElement("div", { key: "".concat(i, "-").concat(k), onClick: function () {
                    // Deep clone grid
                    var newGrid = JSON.parse(JSON.stringify(grid));
                    newGrid[i][k] = grid[i][k] ? 0 : 1;
                    setGrid(newGrid);
                }, style: {
                    width: 20,
                    height: 20,
                    backgroundColor: grid[i][k] ? theme.colors[0] : undefined,
                    border: "none",
                } })); });
        }))));
};
exports.default = Life;
